import { render, staticRenderFns } from "./myCustomer.vue?vue&type=template&id=25ae12a5&"
import script from "./myCustomer.vue?vue&type=script&lang=js&"
export * from "./myCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ae12a5')) {
      api.createRecord('25ae12a5', component.options)
    } else {
      api.reload('25ae12a5', component.options)
    }
    module.hot.accept("./myCustomer.vue?vue&type=template&id=25ae12a5&", function () {
      api.rerender('25ae12a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/myCustomer.vue"
export default component.exports